import { render, staticRenderFns } from "./TaskAssignmentMetaData.vue?vue&type=template&id=81a47f80"
import script from "./TaskAssignmentMetaData.vue?vue&type=script&lang=js"
export * from "./TaskAssignmentMetaData.vue?vue&type=script&lang=js"
import style0 from "./TaskAssignmentMetaData.vue?vue&type=style&index=0&id=81a47f80&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports